import styled from '@emotion/styled';

export const LabelContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.sm};
`;
